const provincias = [
  {
    value: "Zaragoza",
    label: "Zaragoza",
  },
  {
    value: "Huesca",
    label: "Huesca",
  },
  {
    value: "Teruel",
    label: "Teruel",
  },
];

export default provincias;
